module.exports = __webpack_public_path__ + "img/qzApk.8c064155.png";